// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import PastDueOrders from './past-due-orders';
import React from 'react';

function PastDueOrdersPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-availability-page">
            <PastDueOrders />
        </AuthenticatedPage>
    );

}
PastDueOrdersPage.displayNAme = 'PastDueOrdersPage';

export default PastDueOrdersPage;
